import { BigNumber } from 'bignumber.js';
import { JSEncrypt } from 'jsencrypt';
import moment from 'moment';

const timeWorker: any = {};

export const myClearInterval = (key: number) => {
  if (Reflect.has(timeWorker, key)) {
    clearTimeout(timeWorker[key]);
    Reflect.deleteProperty(timeWorker, key);
  }
};

export const mySetInterval = (fn: Function, time: number, count?: number) => {
  const key: any = Symbol('timer_key');
  let executeCount = count;

  const execute = (fn1: Function, time1: number) => {
    if (typeof executeCount === 'number' && executeCount <= 0) {
      myClearInterval(key);
      return;
    }

    timeWorker[key] = setTimeout(() => {
      fn1();

      if (typeof executeCount === 'number' && executeCount > 0) {
        executeCount -= 1;
      }

      execute(fn1, time1);
    }, time1);
  };

  execute(fn, time);

  return key;
};

export const createSliderMarks = (max: number | string, min: number | string) => {
  if (max && min) {
    const step = new BigNumber(max)
      .minus(min)
      .plus(1)
      .div(5)
      .integerValue(3);

    const points: { [key: number]: string } = {};
    for (let i = 1; i <= 4; i += 1) {
      const p = step
        .times(i)
        .plus(min)
        .minus(1)
        .toNumber();

      points[p] = `${p}X`;
    }

    return {
      [min]: `${min}X`,
      ...points,
      [max]: `${max}X`,
    };
  }

  return { 0: '', 25: '', 50: '', 75: '', 100: '' };
};

// rsa 加密
export function encryptEncode(data: any, publicKey: string) {
  const encryptor = new JSEncrypt();
  encryptor.setPublicKey(publicKey);

  return encryptor.encrypt(data);
}

export function generateNonceStr(length: number, type?: string) {
  let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  type === 'num' && (chars = '0123456789');
  const maxPos = chars.length;
  let noceStr = '';
  for (let i = 0; i < (length || 32); i++) {
    noceStr += chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return noceStr;
}

export function getClientCode() {
  let clientCode = window.localStorage.getItem('clientCode');

  if (!clientCode || clientCode.length !== 32) {
    clientCode = Date.now() + generateNonceStr(19);
    window.localStorage.setItem('clientCode', clientCode);
  }

  return clientCode;
}

export function transformTime(
  startTime = 'startTime',
  endTime = 'endTime',
  startTimeNUmber?: number,
  endTimeNUmber?: number,
) {
  if (!startTimeNUmber || !endTimeNUmber) {
    return {};
  }
  //     date.setHours(0, 0, 0, 0); // 参数依次是小时、分钟、秒、毫秒
  let MinTime = new Date(new Date(startTimeNUmber).setHours(0, 0, 0, 0)).getTime(); // 开始时间 00点0分0秒
  // let MaxTime = new Date(endTimeNUmber).getTime() + 24 * 60 * 60 * 1000 - 1;// 结束时间：23点59分59秒
  let MaxTime = new Date(new Date(endTimeNUmber).setHours(23, 59, 59, 999)).getTime(); // 结束时间：23点59分59秒

  return {
    [startTime]: MinTime,
    [endTime]: MaxTime,
  };
}
